import { SVGProps } from 'react';

const IcSMS = (props: SVGProps<SVGSVGElement>) => {
  return (
    <span className='anticon anticon-pie-chart ant-menu-item-icon'>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M2.08325 1.56836L18.9466 10.0001L2.08325 18.4317V11.6545L4.39953 10.0001L2.08325 8.34557V1.56836ZM6.10031 10.8334L3.74992 12.5122V15.735L13.5532 10.8334H6.10031ZM13.5532 9.16672H6.10031L3.74992 7.48787V4.26508L13.5532 9.16672Z'
          fill={props.fill || '#64748B'}
        />
      </svg>
    </span>
  );
};

export default IcSMS;
